import React from 'react';

import { FlexColumn, FlexRow } from '@editor/components/utilities/layouts';
import { withEventScope } from '@repo/event-processor';
import { H6, H4, P3 } from '@repo/ui/components/Typography';
import { themeStyle } from '@repo/ui/theming';

import { formatMonetaryValue } from '../../../utils/billing';
import { NextChargeData } from '../hooks/types';

import { TableRow } from './styles';

/**
 * This component displays the details of the next payment for a subscription, including the amount and any additional notes.
 */
const NextPaymentSection: React.FC<{ nextCharge: NextChargeData }> = ({
  nextCharge,
}) => (
  <FlexColumn gap="4px">
    <TableRow>
      <H6>{nextCharge.label}</H6>
      <H4 style={{ textAlign: 'right' }}>
        {formatMonetaryValue(nextCharge.value)}
      </H4>
    </TableRow>
    {/* Display additional notes if available */}
    {nextCharge.note && (
      <TableRow>
        <FlexRow alignItems="center" gap="4px">
          <H6>{nextCharge.note.title}</H6>
          <P3 color={themeStyle.varInkMedium}>{nextCharge.note.description}</P3>
        </FlexRow>
        <H4 style={{ textAlign: 'right' }}>
          {formatMonetaryValue({
            ...nextCharge.value,
            amount: nextCharge.note.amount,
          })}
        </H4>
      </TableRow>
    )}
  </FlexColumn>
);

export default withEventScope(NextPaymentSection, {
  module: 'nextPaymentSection',
});
